export const LAST_AUTH_UID_SESSION_KEY = "lastAuthUid";
export const LIKELY_AUTH_SESSION_LOCAL_KEY = "likelyAuthSession";

function readStorageItem(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorageItem(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch {
    // Ignore private-mode storage failures.
  }
}

function removeStorageItem(storage, key) {
  try {
    storage.removeItem(key);
  } catch {
    // Ignore private-mode storage failures.
  }
}

export function getLastAuthUid() {
  if (typeof window === "undefined") return null;
  return readStorageItem(window.sessionStorage, LAST_AUTH_UID_SESSION_KEY);
}

export function rememberLikelyAuthSession(uid) {
  if (typeof window === "undefined" || !uid) return;

  writeStorageItem(window.sessionStorage, LAST_AUTH_UID_SESSION_KEY, uid);
  writeStorageItem(window.localStorage, LIKELY_AUTH_SESSION_LOCAL_KEY, "true");
}

export function clearLikelyAuthSession() {
  if (typeof window === "undefined") return;

  removeStorageItem(window.sessionStorage, LAST_AUTH_UID_SESSION_KEY);
  removeStorageItem(window.localStorage, LIKELY_AUTH_SESSION_LOCAL_KEY);
}

export function hasLikelyAuthSession() {
  if (typeof window === "undefined") return false;

  return Boolean(
    readStorageItem(window.sessionStorage, LAST_AUTH_UID_SESSION_KEY)
    || readStorageItem(window.localStorage, LIKELY_AUTH_SESSION_LOCAL_KEY) === "true"
  );
}
